import { AfterViewInit, ElementRef, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../../../app/shared/_services/storage.service';
declare var Swiper: any;

@Component({
  selector: 'app-blocco-collage',
  templateUrl: './blocco-collage.component.html',
  styles: []
})
export class BloccoCollageComponent implements OnInit, AfterViewInit {

  constructor(private elementRef: ElementRef, private storage: StorageService) { }

  @Input() campi;
  swiper;

  ngOnInit() {
  }

  ngAfterViewInit() {
    if ( this.storage.isBrowser ) {
      this.swiper = new Swiper(this.elementRef.nativeElement.querySelector('#block-breaking-news .slider'), {
        wrapperClass: 'news',
        slideClass: 'item',
        loop: false,
        pagination: {
          el: '#block-breaking-news .slider-pager',
          bulletActiveClass: 'current',
          clickable: true
        },
        autoplay: {
          delay: 4000,
        },
      });
    }
  }

}
